// src/pages/NotFoundPage.js
import React from 'react';

function NotFoundPage() {
  return <h1>404 - Página no encontrada</h1>;
}

export default NotFoundPage;
